__webpack_require__.p = "/wp-content/plugins/tribu_formations/dist/";